/**
 * Cabelo — Full Screen Desktop Mega Menu (NO OVERLAY)
 * ---------------------------------------------------
 * • Full-height fixed mega under header
 * • Dynamic top offset via CSS var --cabelo-mega-top (viewport px)
 * • Hover stays open when cursor moves into mega (no flicker)
 * • Click locks open on desktop
 * • ESC + outside click close
 */

(() => {
  const nav = document.querySelector('.cabelo-nav');
  if (!nav) return;

  const items = Array.from(nav.querySelectorAll('.cabelo-nav__item[data-mega-item]'));
  if (!items.length) return;

  const headerEl =
    document.querySelector('#header-component') ||
    document.querySelector('#header-group') ||
    document.querySelector('header');

  const mqDesktop = window.matchMedia('(min-width: 990px)');
  const isDesktop = () => mqDesktop.matches;

  const OPEN_DELAY = 110;
  const CLOSE_DELAY = 160;
  const SWITCH_DELAY = 60;


  // Measure header bottom in VIEWPORT px (fixed positioning needs viewport coords)
  const setMegaTop = () => {
    if (!headerEl) return;
    const rect = headerEl.getBoundingClientRect();
    document.documentElement.style.setProperty('--cabelo-mega-top', `${Math.round(rect.bottom)}px`);
  };

  setMegaTop();
  window.addEventListener('resize', setMegaTop, { passive: true });
  window.addEventListener('scroll', setMegaTop, { passive: true });

  const mo = new MutationObserver(setMegaTop);
  if (headerEl) mo.observe(headerEl, { childList: true, subtree: true, attributes: true });

  const setOpenState = (open) => {
    // keep this class if you want to style "mega open" states (like locking scroll)
    document.documentElement.classList.toggle('cabelo-mega-open', open);
  };

  const closeAll = () => {
    items.forEach((item) => {
      item.classList.remove('is-open', 'is-locked');
      const link = item.querySelector('.cabelo-nav__link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
    setOpenState(false);
  };

  const openItem = (item, lock = false) => {
    setMegaTop();
    closeAll();

    item.classList.add('is-open');
    if (lock) item.classList.add('is-locked');

    const link = item.querySelector('.cabelo-nav__link');
    if (link) link.setAttribute('aria-expanded', 'true');

    setOpenState(true);
  };

  items.forEach((item) => {
    const link = item.querySelector('.cabelo-nav__link');
    const mega = item.querySelector('.cabelo-mega');
    if (!link || !mega) return;

    let tOpen = null;
    let tClose = null;

    const scheduleOpen = () => {
      if (!isDesktop()) return;
      if (item.classList.contains('is-locked')) return;
      clearTimeout(tClose);
      clearTimeout(tOpen);
      const anyOpen = items.some(i => i.classList.contains('is-open') || i.classList.contains('is-locked'));
      const delay = anyOpen ? SWITCH_DELAY : OPEN_DELAY;
      tOpen = window.setTimeout(() => openItem(item, false), delay);

        };

    const scheduleClose = () => {
      if (!isDesktop()) return;
      if (item.classList.contains('is-locked')) return;
      clearTimeout(tOpen);
      clearTimeout(tClose);
      tClose = window.setTimeout(() => closeAll(), CLOSE_DELAY);
    };

    // Hover behavior (LI + mega are both "safe zones")
    item.addEventListener('mouseenter', scheduleOpen);
    item.addEventListener('mouseleave', scheduleClose);

    mega.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      clearTimeout(tClose);
    });
    mega.addEventListener('mouseleave', scheduleClose);

    // Click behavior:
    // Desktop:
    //   - first click opens + locks
    //   - second click unlocks + navigates (we allow navigation by not preventing default)
    // Mobile/tablet:
    //   - mega is hidden by CSS, so normal navigation happens
    link.addEventListener('click', (e) => {
      const hasMega = !!mega;
      if (!hasMega) return;

      // If mega is not active (desktop only), open it instead of navigating
      if (isDesktop()) {
        const isOpenNow = item.classList.contains('is-open');
        const isLocked = item.classList.contains('is-locked');

        if (!isOpenNow) {
          e.preventDefault();
          clearTimeout(tClose);
          clearTimeout(tOpen);
          openItem(item, true); // lock on first click
          return;
        }

        if (isLocked) {
          // unlock + close and allow navigation
          closeAll();
          return;
        }

        // open but not locked -> lock it
        e.preventDefault();
        openItem(item, true);
      }
    });
  });

  // ESC closes
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  // Click outside closes (no overlay)
  document.addEventListener('click', (e) => {
    if (e.target.closest('.cabelo-nav')) return;
    if (e.target.closest('.cabelo-mega')) return;
    closeAll();
  });

  // On resize breakpoint changes, close
  window.addEventListener(
    'resize',
    () => {
      setMegaTop();
      closeAll();
    },
    { passive: true }
  );
})();
